module.exports = __webpack_public_path__ + "img/9788954607223.b5fe7010.jpg";